import Select from '@/components/Form/Select/index.vue';

import { YEARS_RANGE, COUNT_MONTH } from '@/constants/constants';


export default {
  props: ['errorMessage', 'date', 'title', 'required'],

  data() {
    return {
      day: null,
      month: null,
      year: null,
      focus: {
        year: false,
        month: false,
        day: false,
      },
      isError: false,
    };
  },

  components: {
    Select,
  },

  mounted() {
    if (this.date) {
      const newDate = new Date(this.date);
      this.year = newDate.getFullYear();
      this.month = {
        index: newDate.getMonth(),
        name: this.months[newDate.getMonth()],
      };
      this.day = newDate.getDay();
    }
  },

  watch: {
    day() {
      this.setDate();
    },

    month() {
      this.setDate();
    },

    year() {
      this.setDate();
    },
  },

  computed: {
    days() {
      return new Date(
        this.year,
        this.month && this.month.id + 1,
        0,
      ).getDate();
    },

    months() {
      let id = -1;

      const locale = this.$i18n.locale === 'cn' ? 'zh' : this.$i18n.locale;

      return Array.from({ length: COUNT_MONTH }, (v, k) => {
        id += 1;
        const date = new Date(0);
        const shiftedDate = new Date(date.setMonth(date.getMonth() + k));
        const month = shiftedDate.toLocaleString(locale, { month: 'long' });

        return { id, name: month[0].toUpperCase() + month.slice(1) };
      });
    },

    years() {
      const startYear = new Date().getFullYear() - YEARS_RANGE;
      return Array.from({ length: YEARS_RANGE }, (v, k) => k + startYear)
        .slice()
        .reverse();
    },
  },

  methods: {
    validate() {
      if (!this.$refs.day.validate()) {
        this.isError = true;
      }
      if (!this.$refs.month.validate()) {
        this.isError = true;
      }
      if (!this.$refs.year.validate()) {
        this.isError = true;
      }

      return !this.isError;
    },

    setDate() {
      this.isError = false;
      this.$emit('onChange');

      if (this.day && this.month && this.year) {
        const date = new Date();
        date.setFullYear(this.year);
        date.setMonth(this.month.id);
        date.setDate(this.day);
        this.$emit('input', date);
      }
    },

    handleFocus(e) {
      this.focus[e.target.id] = !this.focus[e.target.id];
    },

    resetDay() {
      if (this.day > this.days) {
        this.day = null;
      }
    },
  },
};
